import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const testimonials = [
  {
    quote:
      "We always struggled to find retrofit jobs. But this was like discovering a treasure trove of opportunities — probably 10x bigger than our new-construction business.",
    name: "",
    title: "General Manager",
    company: "$500M Architectural Products Manufacturer",
    bgColor: "#1e3a5f",
  },
  {
    quote: "What Veranda is building is PHENOMENAL!",
    name: "Partner",
    title: "",
    company: "McKinsey & Company",
    bgColor: "#0f2d2d",
  },
  {
    quote: "I have goosebumps right now. We've never been able to see opportunity like this before.",
    name: "",
    title: "Chief Marketing Officer",
    company: "$100M Building Products Manufacturer",
    bgColor: "#2d1f3d",
  },
  {
    quote: "We always knew the retrofit market was huge, but we could never get to it. This changes everything — how we sell, but also potentially what we sell.",
    name: "",
    title: "CEO",
    company: "$150M Siding Manufacturer",
    bgColor: "#1f2d3d",
  },
];

export const TestimonialsSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      className="py-24 px-[5%] border-t border-[#1e1e1e]"
      data-testid="testimonials-section"
    >
      <div className="max-w-content mx-auto">
        <p 
          ref={headerRef}
          className="text-[0.7rem] font-semibold tracking-[3px] uppercase text-[#6b7280] mb-16"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
          }}
        >
          WHAT THEY'RE SAYING
        </p>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((testimonial, idx) => (
            <div
              key={idx}
              className="rounded-[12px] p-8 flex flex-col justify-between min-h-[320px]"
              style={{ 
                background: testimonial.bgColor,
                opacity: cardsVisible ? 1 : 0,
                transform: cardsVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.97)",
                transition: `opacity 0.7s ease-out ${0.1 + idx * 0.15}s, transform 0.7s ease-out ${0.1 + idx * 0.15}s`,
              }}
              data-testid={`testimonial-card-${idx}`}
            >
              <p className="text-[clamp(1.25rem,2.5vw,1.5rem)] text-white font-medium leading-[1.4]">
                "{testimonial.quote}"
              </p>
              <div className="mt-8 pt-6 border-t border-white/20">
                <p className="text-[14px] text-white font-semibold">
                  {testimonial.name && <>{testimonial.name}</>}
                  {testimonial.name && testimonial.title && ", "}
                  {testimonial.title}
                </p>
                <p className="text-[13px] text-white/70">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
